// 429 from the per-user payment-start cap (backend core/deps.enforce_intent_limit).
export const isRateLimited = (e) =>
  e?.response?.status === 429 && e?.response?.data?.detail?.reason === "rate_limited";

export const RATE_LIMITED_KEY = "payments.rateLimited";
